// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import cartLineSharedStyles from "@rpsc/App/SharedStyles/CartLineSharedStyles";
import { cartLineCardExpandedStyles } from "@rpsc/Overrides/Widgets/Cart/CartLineCardExpanded";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { color } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

cartLineCardExpandedStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};

cartLineCardExpandedStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

cartLineCardExpandedStyles.productBrand = {
    ...cartLineSharedStyles.productBrand,
};

cartLineCardExpandedStyles.lineNotesLinkAdd = {
    ...cartLineSharedStyles.lineNotesLinkAdd,
};

cartLineCardExpandedStyles.lineNotesLinkHide = {
    ...cartLineSharedStyles.lineNotesLinkHide,
};

cartLineCardExpandedStyles.cartLineNotes = {
    ...cartLineSharedStyles.cartLineNotes,
};

cartLineCardExpandedStyles.addToListLink = {
    ...cartLineSharedStyles.addToListLink,
};

cartLineCardExpandedStyles.removeCartLineIcon = {
    ...cartLineSharedStyles.removeCartLineIcon,
};
// tab action
cartLineCardExpandedStyles.removeCartLineIconClickable = {
    css: css`
        &:focus {
            ${IconWrapper} svg {
                color: ${color("common.ui8")};
            }
        }
    `,
};

cartLineCardExpandedStyles.extendedUnitNetPriceHeadingAndText = {
    ...cartLineSharedStyles.totalPrice,
};

cartLineCardExpandedStyles.promotionNameText = {
    ...cartLineSharedStyles.promotionNameText,
};

cartLineCardExpandedStyles.productPrice = {
    ...cartLineSharedStyles.productPrice,
};

cartLineCardExpandedStyles.costCodeLabelText = {
    ...cartLineSharedStyles.costCodeLabelText,
};
cartLineCardExpandedStyles.costCodeText = {
    ...cartLineSharedStyles.costCodeValueText,
};

cartLineCardExpandedStyles.productAvailability = {
    ...cartLineSharedStyles.productAvailability,
};

cartLineCardExpandedStyles.cartLineErrorMessageText = {
    ...cartLineSharedStyles.errorMessage,
};

cartLineCardExpandedStyles.cartLineErrorMessageGridItem = {
    ...cartLineSharedStyles.cartLineErrorMessageGridItem,
};

cartLineCardExpandedStyles.totalWrapper = {
    ...cartLineSharedStyles.totalWrapper,
};

cartLineCardExpandedStyles.warningToolTip = {
    ...cartLineSharedStyles.warningToolTip,
};

cartLineCardExpandedStyles.alertWarningIconStyles = {
    ...cartLineSharedStyles.alertWarningIconStyles,
};

cartLineCardExpandedStyles.badgesContainer = {
    ...cartLineSharedStyles.badgesContainer,
};
